import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION, TRACKING_INTERACTION } from 'contexts/AnalyticsContext/Constants';

export const utagRatingViewMore = () => {
  const interactionType = {
    eventType: TRACKING_ACTION.INTERACTION,
    interaction: TRACKING_INTERACTION.RATING_AND_REVIEW.RATING_VIEW_MORE,
  };
  const userInteractionEvent = createUserInteraction(interactionType);
  trackEvent(userInteractionEvent);
};
